import React, {useEffect, useState} from 'react'
import './virtualKeyboard.scss'
import clearIcon from '../../assets/images/clearVk.svg'
import doneIcon from '../../assets/images/doneVK.svg'
import backIcon from '../../assets/images/backVk.svg'
import closeIcon from '../../assets/images/closeVk.svg'

const VirtualKeyboard = (props:any) => {
    useEffect(()=>{
        setsuffledArray(keyArray.sort(() => .5 - Math.random()))
        setsuffledArrayNum(keyArrayNum.sort(() => .5 - Math.random()))

    },[])
    
    const [inputvalue, SetInputValue] = useState("")
    const [capsValue, setCapsValue] = useState(true)
    const [suffledArray, setsuffledArray] = useState([])
    const [suffledArrayNum, setsuffledArrayNum] = useState([])
    const [close, setClose] = useState(false)

    let keyArrayNum:any = [
        {s:"`",c:"~"},
        {s:"1",c:"!"},
        {s:"3",c:"#"},
        {s:"4",c:"$"},
        {s:"2",c:"@"},
        {s:"5",c:"%"},
        {s:"6",c:"^"},
        {s:"7",c:"&"},
        {s:"8",c:"*"},
        {s:"9",c:"("},
        {s:"0",c:")"},
        {s:"=",c:"+"},
    ]
    let keyArray:any = [
        {s:"a",c:"A"},
        {s:"b",c:"B"},
        {s:"c",c:"C"},
        {s:"d",c:"D"},
        {s:"e",c:"E"},
        {s:"f",c:"F"},
        {s:"g",c:"G"},
        {s:"h",c:"H"},
        {s:"i",c:"I"},
        {s:"j",c:"J"},
        {s:"k",c:"K"},
        {s:"l",c:"L"},
        {s:"m",c:"M"},
        {s:"n",c:"N"},
        {s:"o",c:"O"},
        {s:"p",c:"P"},
        {s:"q",c:"Q"},
        {s:"r",c:"R"},
        {s:"s",c:"S"},
        {s:"t",c:"T"},
        {s:"u",c:"U"},
        {s:"v",c:"V"},
        {s:"w",c:"W"},
        {s:"x",c:"X"},
        {s:"y",c:"Y"},
        {s:"z",c:"Z"},
        {s:"/",c:"?"},
        {s:"[",c:"{"},
        {s:"]",c:"}"},
        {s:"/",c:"?"},
        {s:"-",c:"_"},
        {s:";",c:":"},
        {s:"'",c:'"'},
        {s:",",c:"<"},
        {s:".",c:">"},
    ]

const handlebutton = (e:any) =>{
    SetInputValue(`${inputvalue}${e.target.value}`)
}
const handleCaps = () => {
    setCapsValue(!capsValue)
}

const handleDone = () => {
    props.virtualPassword(inputvalue);
    props.closeKeyboard(close);
    SetInputValue("")
}

const handleClear = () => {
    SetInputValue("")
}

const handleBack = () => {
    SetInputValue(inputvalue.slice(0,-1))
}

const handleClose = () => {
    props.closeKeyboard(close);
    setClose(true)
}

  return (
         <div className='virtualContainer'>
             <div className='heading'>
                <span className='headerTxt'>SECURED VIRTUAL KEYPAD</span>
                <img src= {closeIcon} onClick={handleClose}/> 
            </div>
             <div className="firstrow">
                 <input className= "textBox" value={inputvalue} onChange={()=>{}} type="password" />
                 <button onClick={handleClear} className="actionButon"> <img className="" src={clearIcon} /><span>Clear</span></button>
                 <button onClick={handleBack} className="actionButon"><img className="" src={backIcon} /><span>Back</span></button>
                 <button onClick={handleDone} className="actionButon"><img className="" src={doneIcon} /><span>Done</span></button>
             </div>
             <div className='keyGroup'>
             <div className='secondRow'>
             <button className= "capsButton" onClick={handleCaps}><span className={capsValue?'capsActive':'capsInactive'}></span>Caps/123</button>
             {suffledArrayNum.length ? suffledArrayNum.map((e:any, i)=>(
                    <button className="bottomKeys" key ={i} onClick={(e)=>handlebutton(e)} value={capsValue? e.c : e.s}>{capsValue ? e.c : e.s}</button>
                )):null}
             </div>
             <div className='thirdRow'>
             
                {suffledArray.length ? suffledArray.map((e:any, i)=>(
                    <button className="bottomKeys" key ={i} onClick={(e)=>handlebutton(e)} value={capsValue? e.c : e.s}>{capsValue ? e.c : e.s}</button>
                )):null}
             </div>
             </div>
        </div>
  )
}

export default VirtualKeyboard;